import DefaultMainPage from "../../pages/DefaultMainPage";
import CouponMaster from "./couponMaster/CouponMaster";
import CouponSeed from "./couponSeed/CouponSeed";

const couponMenuItems = [
    {path: "/coupon", component: <CouponMaster/>, label: '쿠폰 관리'},
    {path: "/coupon/seed", component: <CouponSeed/>, label: '쿠폰 시드'},
];

export const couponRoutes = {
    path: "/coupon",
    component: <DefaultMainPage buttons={couponMenuItems}/>,
    children: couponMenuItems
}